<template>
	<div class="incenters">
		<!-- style="border: 1px solid red;" -->
		<div>
			<!-- <Commonbtn title="导出"></Commonbtn> -->
			<div class="topstate" v-for="(item , index) of state" :key="index" :class="[{ 'ativte' : onchage == index}]"
				@click="clicktab(index)">
				{{ item.title }}
			</div>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div v-if="tableflag" style="overflow-x: scroll;" class="TableWidth">
			<Commontable :rowhe="false" colnum=7 :loadingTable="loadingTable" :tableData="tableDataDetail"
				:headerData="headerData" height="100%"></Commontable>
		</div>
		<div class="TableWidth" v-if="tableflags">
			<Commontable colnum=7 :tableData="tableDataUnique" :loadingTable="loadingTable" :headerData="headerData1"
				height="100%"></Commontable>
		</div>
	</div>
</template>

<script>
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import {
		wmsDespatchDetail,
		wmsDespatchDetailUnique
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
		},
		props: {
			dpmid: {
				type: String,
				default: ""
			},
			tableDataUnique: {
				type: Array,
				default: []
			},
			tableDataDetail: {
				type: Array,
				default: []
			},
		},
		data: function() {
			return {
				loadingTable: false,
				headerData1: [{
						prop: 'id',
						label: '序号',
						columnwidth: 40
					},
					{
						prop: 'Batch',
						label: '批号',
						columnwidth: 120
					},
					{
						prop: 'InvUniqueCode',
						label: '唯一码',
						columnwidth: 100
					},
					{
						prop: 'Quantity',
						label: '数量',
						columnwidth: 50
					},

				],
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 40
					},
					{
						prop: 'InvAddCode',
						label: '商品代码',
						columnwidth: 130
					},
					{
						prop: 'InvName',
						label: '存货名称',
						columnwidth: 130
					},
					{
						prop: 'Batch',
						label: '批号',
						columnwidth: 100
					},
					{
						prop: 'ValiDate',
						label: '有效期至',
						columnwidth: 130
					},
					{
						prop: 'Quantity',
						label: '数量',
						columnwidth: 50
					},
					{
						prop: 'VouDCode',
						label: '来源单据表体编号',
						columnwidth: 150
					},
					{
						prop: 'TaxUnitPrice',
						label: '原币含税单价',
						columnwidth: 100
					},
					{
						prop: 'TaxRate',
						label: '税率',
						columnwidth: 50
					},
					{
						prop: 'ExchangeRate',
						label: '汇率',
						columnwidth: 50
					},
					{
						prop: 'UnitPrice',
						label: '原币单价',
						columnwidth: 80
					},
					{
						prop: 'UnitPrice',
						label: '原币单价',
						columnwidth: 100
					},
					{
						prop: 'Sum',
						label: '原币价税合计',
						columnwidth: 110
					},
					{
						prop: 'Money',
						label: '原币金额',
						columnwidth: 100
					},
					{
						prop: 'TaxPrice',
						label: '原来税额',
						columnwidth: 100
					},
					{
						prop: 'NatSum',
						label: '本币价税合计',
						columnwidth: 110
					},
					{
						prop: 'NatMoney',
						label: '本币金额',
						columnwidth: 100
					},
					{
						prop: 'NatTaxPrice',
						label: '本币税额',
						columnwidth: 100
					},
					{
						prop: 'InvoiceNo',
						label: '发票号',
						columnwidth: 80
					},
					{
						prop: 'BillQuantity',
						label: '开票数量',
						columnwidth: 100
					},
					{
						prop: "DetailRemark1",
						label: "明细备注1",
						columnwidth: 160,
					},
					{
						prop: "DetailRemark2",
						label: "明细备注2",
						columnwidth: 160,
					},
					{
						prop: "DetailRemark3",
						label: "明细备注3",
						columnwidth: 160,
					}
				],
				state: [{
						title: '明细'
					},
					{
						title: '唯一码'
					}
				],
				onchage: 0,
				tableflag: true,
				tableflags: false,
			}
		},
		created() {},
		mounted() {},
		methods: {
			// 明细
			async wmsDespatchDetail() {
				let {
					data,
					code
				} = await wmsDespatchDetail({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetail = data
				}
			},
			// 唯一码
			async wmsDespatchDetailUnique() {
				let {
					data,
					code
				} = await wmsDespatchDetailUnique({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetail = data
				}
			},
			clicktab(index) {
				if (index == 0) {
					this.tableflag = true
					this.tableflags = false
					this.wmsDespatchDetail()
				}
				if (index == 1) {
					this.tableflag = false
					this.tableflags = true
					this.wmsDespatchDetailUnique()
				}
				if (this.onchage != index) {
					this.onchage = index
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.ativte {
		border: 1px solid red;
		color: #e71d43;
		background-color: #fce8ec;
		transition: 0.2s linear;
	}

	.incenters {
		height: 100%;
		font-family: "微软雅黑";
		background-color: #fff;
		width: 980px;
		margin-top: 10px;
		padding-bottom: 10px;
		padding-top: 2px;
		box-shadow: rgb(0 0 0 / 10%) 0px 1px 4px 0px;
		background-color: rgb(255, 255, 255);

		div {
			margin-left: 8px;
			margin-right: 8px;
			margin-top: 5px;
			margin-bottom: 5px;
			// width: 100%;
		}
	}

	.topstate {
		width: 100px;
		height: 32px;
		font-size: 14px;
		border: 1px solid #e6e6e6;
		line-height: 32px;
		text-align: center;
		cursor: pointer;
		display: inline-block;
	}
</style>